import AnimatedContent from './AnimatedContent';

export default AnimatedContent;
